import styled, { keyframes } from 'styled-components';

const pulseOutline = keyframes`
  0%, 100% {
    outline-color: red;
    outline-width: 1px;
  }
  50% {
    outline-color: rgba(255, 0, 0, 0.5);
    outline-width: 2px;
  }
`;

export const PublishStatusStyle = styled.span`
  font-weight: bold;
  font-size: 8px;
  visibility: hidden; 
  opacity: 0; 
  position: absolute;
  left: 15px;
  white-space: nowrap;
  transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out;
  color: ${(props) => props.theme['themeId'] === 'dark'
    ? props.theme['color.white']
    : props.theme['color.text.body']};
`;

export const PublishStatusCircle = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${(props) => props.color};
  margin-top: 2px;
  position: relative;
  outline: ${(props) => props.marketsExist ? '1px solid red' : 'none'};
  outline-offset: 2px;
  animation: ${(props) => props.marketsExist ? pulseOutline : 'none'} 2s ease-in-out infinite;

  &:hover ${PublishStatusStyle} {
    visibility: visible;
    opacity: 1;
  }
`;

export const HollowCircle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 8px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  position: relative;
  background: ${(props) => props.theme['color.redLight']};
  color: white;
  overflow: 'hidden';

  &::before {
    content: "!";
    display: inline-block;
    font-size: 12px;
    font-weight: bolder;
  }

  &:hover ${PublishStatusStyle} {
    visibility: visible;
    opacity: 1;
  }
`;
